import axios from 'axios'
const URL = process.env.REACT_APP_DOBBY_URL

export const createContent = (data) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'post',
      url: `${URL}/api/v1/content`,
      data: data,
    })
    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const updateContent = (data, content_id) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `${URL}/api/v1/content?content_id=${content_id}`,
      data: data,
    })
    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const getContentCall = (id) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: id ? `${URL}/api/v1/content?content_id=${id}` : `${URL}/api/v1/content`,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const deleteContent = (content_id) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'delete',
      url: `${URL}/api/v1/content?content_id=${content_id}`,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}
